import React, { useEffect, useState } from "react";
import { Button, Card, Col, Container, Form, Row } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import { useScreenSize, useCustomScreen } from "./Utils";
const LinkSignUp = ({ page }) => {
  const navigate = useNavigate();
  const {
    isSmallScreen,
    isMediumScreen,
    isLargeScreen,
    isXlScreen,
    isXxlScreen,
    is4kScreen,
  } = useScreenSize();
  const { isIpadProPortrait } = useCustomScreen();
  return (
    <Row>
      <Col
        md={12}
        style={{ height: "100%" }}
        className="d-flex justify-content-center align-items-center my-auto"
      >
        <div className="g-4 d-flex justify-content-center align-items-center">
          <div className={`${page !== "login" ? "" : "d-none"} pb-2`}>
            <Link to="/login" style={{ textDecoration: "none" }}>
              Login
            </Link>
          </div>
          <div
            className="d-flex justify-content-center align-items-center"
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              textAlign: "center",
              padding: "0px 2em",
            }}
          >
            <p
              className="login-heading"
              style={{
                fontSize: is4kScreen
                  ? "3rem"
                  : isXxlScreen
                  ? "1.8rem"
                  : isXlScreen
                  ? "1.5rem"
                  : isIpadProPortrait
                  ? "2.1rem"
                  : isLargeScreen
                  ? "1.7rem"
                  : isMediumScreen
                  ? "1.6rem"
                  : "1.2rem",
              }}
            >
              Don't have an account?
            </p>
            <br></br>
            <p
              style={{
                fontSize: is4kScreen
                  ? "2rem"
                  : isXxlScreen
                  ? "1.25rem"
                  : isXlScreen
                  ? "1.05rem"
                  : isIpadProPortrait
                  ? "1.8rem"
                  : isLargeScreen
                  ? "1rem"
                  : isMediumScreen
                  ? "1.3rem"
                  : isSmallScreen
                  ? ""
                  : "1rem",
              }}
            >
              {" "}
              It's easy and free to sign up!
            </p>
            <br></br>
            <Button
              variant="primary"
              type="submit"
              className="login-btns btn mb-3"
              onClick={() => navigate("/signup")}
              style={{
                fontSize: is4kScreen
                  ? "2rem"
                  : isXxlScreen
                  ? "1.25rem"
                  : isXlScreen
                  ? "1.05rem"
                  : isIpadProPortrait
                  ? "1.8rem"
                  : isLargeScreen
                  ? "1rem"
                  : isMediumScreen
                  ? "1.3rem"
                  : isSmallScreen
                  ? ""
                  : "1rem",
              }}
            >
              Sign Up
            </Button>
          </div>
        </div>
      </Col>
    </Row>
  );
};
export default LinkSignUp;
